const mealOfDayMap = {
  BREAKFAST: 'Breakfast',
  MIDDLE_MORNING: 'Middle Morning',
  LUNCH: 'Lunch',
  MIDDLE_AFTERNOON: 'Middle Afternoon',
  DINNER: 'Dinner',
  AFTER_DINNER: 'After Dinner',
}

const mealPartMap = {
  MAIN_DISH: 'Main Dish',
  SOUP: 'Soup',
  DESSERT: 'Dessert',
  DRINK: 'Dessert',
  FRUIT: 'Fruit',
  CEREAL: 'Cereal',
  VEGETABLE: 'Vegetable',
}

const foodGroupKnownTypesMap = {
  MILK: 'Milk and Milk Products',
  VEGETABLE: 'Vegetables',
  FRUIT: 'Fruit and fruit products',
  CEREALS: 'Cereals',
  BREAKFAST_CEREALS: 'Cereals for Snacks',
  MAIN_DISH_CEREAL: 'Cereal for Main Dishes',
  LEGUME: 'Pulse and Pulse Products',
  MEAT: 'Meat and Meat Products',
  FISH: 'Fish and Fish Products',
  EGGS: 'Eggs and Egg products',
  OIL: 'Oil or Fat',
  SOUP: 'Soups',
  SAUCE: 'Sauces',
  DESSERT_COMFORT: 'Dessert Comfort Food',
  SNACK_COMFORT: 'Snack Comfort Food',
  BEVERAGE: 'Beverages',
  SUGAR: 'Sugar and Sugar Products',
  COMMON_FRUIT: 'Common Fruit',
  OILY_FISH: 'Oily Fish',
}

const ingredientProcessTypes = {
  BOILED: 'Boiled',
  STEWED: 'Stewed',
  GRILLED: 'Grilled',
  ROASTED: 'Roasted',
  FRIED: 'Fried',
  RAW: 'Raw',
}

const dietaryRestrictionMap = {
  VEGAN: 'Vegan',
  VEGETARIAN: 'Vegetarian',
  DIABETES: 'Diabetes',
}

const heuristicNamesMap = {
  'meal_of_day_division.IngredientVarietyHeuristic': 'Ingredient Variety',
  'meal_of_day_division.LitreOfSoupInARow': 'Consecutive soup',
  'meal_of_day_division.CheaperFoodHeuristic': 'Cheaper Food',
  'meal_of_day_division.MinimizeProductCategoriesHeuristic': 'Minimize Product Categories',
  'meal_of_day_division.UserPreferencesHeuristic': 'Food Preferences',
  'meal_of_day_division.EnergySuitabilityHeuristic': 'Energy Suitability',
  'meal_of_day_division.MeatFishSeparationHeuristic': 'Meat Fish Separation',
  'meal_of_day_division.LimitMainDishRecipeRepetition': 'Limit Main Dish Repetition',
  'meal_of_day_division.NoComfortFoodHeuristic': 'No Comfort Food',
  'meal_of_day_division.LowSugarDrinks': 'Low Sugar Drinks',
  'meal_of_day_division.CommonFruitHeuristic': 'Prefer Common Fruit',
  'day.FruitVarietyDayHeuristic': 'Daily Fruit Variety',
  'week.NLFishHeuristic': 'Include Lean and Oily Fish',
  'week.IncludeWhiteMeatHeuristic': 'White Meat',
  'meal_of_day_division.FatSuitabilityHeuristic': 'Fat needs',
  'meal_of_day_division.CarbohydrateSuitabilityHeuristic': 'Carbohydrate needs',
  'meal_of_day_division.ProteinSuitabilityHeuristic': 'Protein needs',
  'meal_of_day_division.DiabetesHeuristic': 'Diabetes',
  'meal_of_day_division.FoodRestrictionsEnforcementHeuristic': 'Food restrictions',
  'meal_of_day_division.RecipesToAvoidInThePlanHeuristic': 'Recipes to avoid',
  'meal_of_day_division.SeasonHeuristic': 'Season',
}

const heuristicAbbrNamesMap = {
  'meal_of_day_division.IngredientVarietyHeuristic': 'IV',
  'meal_of_day_division.LitreOfSoupInARow': 'CS',
  'meal_of_day_division.CheaperFoodHeuristic': 'CF',
  'meal_of_day_division.MinimizeProductCategoriesHeuristic': 'MPC',
  'meal_of_day_division.UserPreferencesHeuristic': 'FP',
  'meal_of_day_division.EnergySuitabilityHeuristic': 'ES',
  'meal_of_day_division.MeatFishSeparationHeuristic': 'MFS',
  'meal_of_day_division.LimitMainDishRecipeRepetition': 'LMDRR',
  'meal_of_day_division.NoComfortFoodHeuristic': 'NCF',
  'meal_of_day_division.LowSugarDrinks': 'LSD',
  'meal_of_day_division.CommonFruitHeuristic': 'CFrt',
  'day.FruitVarietyDayHeuristic': 'DFV',
  'week.NLFishHeuristic': 'ILOF',
  'week.IncludeWhiteMeatHeuristic': 'WM',
  'meal_of_day_division.FatSuitabilityHeuristic': 'FN',
  'meal_of_day_division.CarbohydrateSuitabilityHeuristic': 'CN',
  'meal_of_day_division.ProteinSuitabilityHeuristic': 'PN',
  'meal_of_day_division.DiabetesHeuristic': 'Db',
  'meal_of_day_division.FoodRestrictionsEnforcementHeuristic': 'FR',
  'meal_of_day_division.RecipesToAvoidInThePlanHeuristic': 'RAV',
  'meal_of_day_division.SeasonHeuristic': 'Season',
}

export default {
  readableMealOfDay(mealOfDay) {
    return mealOfDayMap[mealOfDay]
  },

  readableMealPart(mealPart) {
    return mealPartMap[mealPart]
  },

  readableMealOfDayDivision: function (mealOfDayDivision, allDivisions) {
    let _mod = this.readableMealOfDay(mealOfDayDivision.mealOfDay)
    const _mp = mealOfDayDivision.name || this.readableMealPart(mealOfDayDivision.mealPart)

    const _isMealOfDayDivided =
      allDivisions.filter((m) => m.mealOfDay === mealOfDayDivision.mealOfDay).length > 1

    if (_isMealOfDayDivided && _mp) {
      _mod += ' (' + _mp + ')'
    }
    return _mod
  },

  readableFoodGroupKnownType: function (knownType) {
    return (knownType && foodGroupKnownTypesMap[knownType]) || ''
  },

  readableIngredientProcess: function (ingredientProcessType) {
    return (
      (ingredientProcessType && ingredientProcessTypes[ingredientProcessType]) ||
      'No process associated'
    )
  },

  dietaryRestrictions: function () {
    return Object.keys(dietaryRestrictionMap)
  },

  readableDietaryRestriction: function (dietaryRestriction) {
    return (dietaryRestriction && dietaryRestrictionMap[dietaryRestriction]) || ''
  },

  mealsOfDay: function () {
    return Object.keys(mealOfDayMap)
  },

  readableHeuristicName(heuristic) {
    return (heuristic && heuristicNamesMap[heuristic]) || heuristic
  },

  readableHeuristicAbbrName(heuristic) {
    return (heuristic && heuristicAbbrNamesMap[heuristic]) || heuristic
  },

  readableWeekPlanState: (state) =>
    state ? state[0].toUpperCase() + state.substring(1).toLowerCase() : state,
}
